import { Navigate, useRoutes, type RouteObject } from 'react-router-dom';
import { AppLayout } from './shared/layout/app-layout';
import { AuthGuard } from './shared/guards/AuthGuard';
import { appModules } from './app/app.module';

/**
 * Árvore de rotas montada a partir dos manifestos dos módulos
 * (`app/app.module.ts`). O app não conhece as rotas internas de cada módulo —
 * apenas as compõe:
 *
 *  - rotas públicas (login etc.) ficam na raiz, fora do layout;
 *  - rotas protegidas ficam aninhadas sob AuthGuard + AppLayout;
 *  - o catch-all redireciona para a home.
 */
const publicRoutes: RouteObject[] = appModules.flatMap(
  (module) => module.publicRoutes ?? [],
);

const protectedRoutes: RouteObject[] = appModules.flatMap(
  (module) => module.routes ?? [],
);

const routes: RouteObject[] = [
  ...publicRoutes,
  {
    element: (
      <AuthGuard>
        <AppLayout />
      </AuthGuard>
    ),
    children: [
      ...protectedRoutes,
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
];

export function AppRoutes() {
  return useRoutes(routes);
}
